export { default as Form } from 'notifications_historic/components/form/NotificationHistoricForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/form/index.js